// src/routes/Index.jsx
import React from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

// Constants & Layouts
import { layoutTypes } from "../constants/layout";
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout";
import AuthProtected from "./AuthProtected";

// Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// Layout selector
const selectLayout = createSelector(
  (state) => state.Layout,
  (layout) => ({
    layoutType: layout.layoutType,
  })
);

// Resolve layout dynamically
const getLayout = (layoutType) => {
  switch (layoutType) {
    case layoutTypes.VERTICAL:
    default:
      return VerticalLayout;
  }
};

const Index = () => {
  const { layoutType } = useSelector(selectLayout);
  const Layout = getLayout(layoutType);

  return (
    <Routes>
      {/* Public Routes */}
      {publicRoutes.map(({ path, component: Component }, idx) => (
        <Route
          path={path}
          key={idx}
          element={
            <NonAuthLayout>
              <Component />
            </NonAuthLayout>
          }
        />
      ))}

      {/* Protected Routes */}
      {authProtectedRoutes.map(({ path, component: Component }, idx) => (
        <Route
          path={path}
          key={idx}
          element={
            <AuthProtected>
              <Layout>
                <Component />
              </Layout>
            </AuthProtected>
          }
        />
      ))}
    </Routes>
  );
};

export default Index;
